import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output ,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwElementsBaseUrlsModel } from '../../../shared/_models/gtw-elements-base-urls.model';
import { MefEfileService } from './mef-efile-changes.service';
import { AdminService } from '../../admin.service';
import { GlobalService } from '../../../global/services/global.service';


@Component({
  selector: 'gtw-mef-efile-changes',
  templateUrl: './mef-efile-changes.component.html',
  styleUrls: ['./mef-efile-changes.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MefEfileChangesComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly datepickerFieldIds = ['returnDate', 'filterTaxYearBegin', 'filterTaxYearEnd', 'dateFiled'];
  private datepickerOutsideListener: ((event: MouseEvent) => void) | null = null;
  disabled: boolean = true;
  isParent: boolean = false;
  minimise: boolean = false;
  syncButtonsEnabled: boolean = false;
  clobDataEmpty: boolean = true;
  allCheckboxesDisable: boolean = false;
  fgEmpty: boolean = false;
  mefTablesDisable: boolean = false;
  disableSave: boolean = false;
  beginDate = new Date(2019, 0, 1);
  endDate = new Date();
  returnDateDates: Date[] = [];
  filterTaxYearBeginDates: Date[] = [];
  filterTaxYearEndDates: Date[] = [];
  dateFiledDates: Date[] = [];
  private scenarioCode: string = '';
  private isIssueKeyEnabled: string = '';
  private isLocked: string = '';
  private issueKey: number = 0;

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  baseGlobalParams: { jcd_key: string; tax_year: string; scenario: string; client_key: string; } | undefined;
  @Input('row-data')
  set _row_data(rowData: string) {
    try {

      let params = JSON.parse(rowData);

      if (params != undefined) {
        this.rowData = params;
        if (this.rowData.IS_PARENT === 'Y') {
          this.isParent = true;
        }
        this.initializeValues();

      }
    } catch (e) {
      console.log("rowData Params not stable. Still waiting to get resolved.");
    }
  }

  @Input('base-urls')
  set _base_urls(baseUrls: string) {
    try {
      let params = JSON.parse(baseUrls);
      if (params != undefined) {
        this.baseURLs = params;
      }
    } catch (e) {
      console.log("base URLs Params not stable. Still waiting to get resolved.");
    }
  }

  @Input('global-params')
  set _global_params(globalParams: string) {
    try {
      let params = JSON.parse(globalParams);
      if (params != undefined) {
        this.baseGlobalParams = params;
      }
    } catch (e) {
      console.log("Global Params not stable. Still waiting to get resolved.");
    }
  }

  @Input("scenario-code")
  set _scenarioCode(scenarioCode: string) {
    this.scenarioCode = scenarioCode;
  }

  @Input("is-issue-key-enabled")
  set _isIssueKeyEnabled(isIssueKeyEnabled: string) {
    this.isIssueKeyEnabled = isIssueKeyEnabled;
  }

  @Input("issue-key")
  set _issueKey(issueKey: number) {
    this.issueKey = issueKey;
  }

  /**
   * Angular 12 ce-host-dialog passes filter-params (tax_year, scenario, jcd_key, client_key)
   * but not global-params. Accept filter-params as a fallback so baseGlobalParams is always set.
   */
  @Input('filter-params')
  set _filterParams(filterParams: string) {
    try {
      const params = typeof filterParams === 'string' ? JSON.parse(filterParams) : filterParams;
      if (params != null && !this.baseGlobalParams) {
        this.baseGlobalParams = {
          jcd_key: String(params.jcd_key ?? ''),
          tax_year: String(params.tax_year ?? ''),
          scenario: String(params.scenario ?? ''),
          client_key: String(params.client_key ?? ''),
        };
      }
    } catch (e) {
      console.log('filter-params not yet stable.');
    }
  }

  mainTabIndex = 0;
  nestedTabIndex = 0;
  baseURLs: GtwElementsBaseUrlsModel = { 'admin': '', 'api': '', "custom": '', 'efile': '', 'pdfEngine': '', 'bulkPdfEngine': '' };
  rowData: any;
  clob_data: any[] = [];
  loader: boolean = false;
  formOne!: FormGroup;
  formTwo!: FormGroup;
  constructor(private mefEfileService: MefEfileService, private datePipe: DatePipe, private _snackBar: MatSnackBar, public dialog: MatDialog, public service: AdminService, private globalService: GlobalService) {
    this.formOne = new FormGroup({
      consolGroupKey: new FormControl('', [Validators.required]),
      filingGroupName: new FormControl(''),
      parentLeKey: new FormControl(''),
      returnDate: new FormControl('', [Validators.required]),
      irsCenterName: new FormControl('VERMONT', [Validators.required]),
      filterTaxYearBegin: new FormControl('', [Validators.required]),
      filterTaxYearEnd: new FormControl('', [Validators.required])
    });
    this.formTwo = new FormGroup({
      leKey: new FormControl(''),
      filerStatus: new FormControl('A'),
      dateFiled: new FormControl('', [Validators.required]),
      lockYN: new FormControl(''),
      fgnDomFlag: new FormControl(''),
      leConsolTypeFlag: new FormControl(''),
      filingGroupKey: new FormControl('', [Validators.required])

    });
    this.service.currentMessage.subscribe(process_name => this.sync(process_name));
    this.service.initiate.subscribe(val => this.dialog.closeAll());
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
  }


  initializeValues(): void {
    // Ensure tab state is reset each time modal receives row data.
    this.mainTabIndex = 0;
    this.nestedTabIndex = 0;

    // Resolve missing inputs from GlobalService when the component is hosted
    // inside the Angular 12 ce-host-dialog (which only passes row-data / base-urls
    // / filter-params but not scenario-code / is-issue-key-enabled / issue-key).
    const gp = this.globalService.global?.globalParams;
    if (!this.scenarioCode && gp?.scenarioCode) {
      this.scenarioCode = String(gp.scenarioCode);
    }
    if (!this.isIssueKeyEnabled && gp?.is_issue_key_enabled) {
      this.isIssueKeyEnabled = String(gp.is_issue_key_enabled);
    }
    if (!this.issueKey && this.rowData?.ISSUE_KEY != null) {
      this.issueKey = Number(this.rowData.ISSUE_KEY);
    }
    // Fallback: populate baseGlobalParams from globalParams if filter-params also missed
    if (!this.baseGlobalParams && gp) {
      this.baseGlobalParams = {
        jcd_key: String(gp.jcd_key ?? ''),
        tax_year: String(gp.tax_year ?? ''),
        scenario: String(gp.scenario ?? ''),
        client_key: String(gp.client_key ?? ''),
      };
    }

    // Parse dates safely - avoid Invalid Date
    const returnDate = this.rowData.RETURN_DATE ? new Date(this.rowData.RETURN_DATE) : null;
    const taxYearBegin = this.rowData.FILER_TAX_YEAR_BEGIN ? new Date(this.rowData.FILER_TAX_YEAR_BEGIN) : null;
    const taxYearEnd = this.rowData.FILER_TAX_YEAR_END ? new Date(this.rowData.FILER_TAX_YEAR_END) : null;

    this.formOne.patchValue({
      consolGroupKey: this.rowData.CONSOL_GROUP_KEY,
      filingGroupName: this.rowData.LE_NAME,
      parentLeKey: this.rowData.LE_KEY,
      returnDate: returnDate,
      filterTaxYearBegin: taxYearBegin,
      filterTaxYearEnd: taxYearEnd
    });
    this.returnDateDates = this.toDateArray(returnDate);
    this.filterTaxYearBeginDates = this.toDateArray(taxYearBegin);
    this.filterTaxYearEndDates = this.toDateArray(taxYearEnd);
    
    this.formTwo.patchValue({
      leKey: this.rowData.LE_KEY,
      lockYN: 'N',
      fgnDomFlag: this.rowData.SOURCE_SYSTEM_FLAG,
      dateFiled: null,
      filingGroupKey: this.rowData.FILING_GROUP_KEY,
    });
    this.dateFiledDates = [];

    // Reset form state - fields should not show errors until user interacts or submits
    // Reset each control individually to ensure clean state
    Object.keys(this.formOne.controls).forEach(key => {
      this.formOne.get(key)?.markAsUntouched();
      this.formOne.get(key)?.markAsPristine();
    });
    Object.keys(this.formTwo.controls).forEach(key => {
      this.formTwo.get(key)?.markAsUntouched();
      this.formTwo.get(key)?.markAsPristine();
    });
    this.formOne.markAsUntouched();
    this.formOne.markAsPristine();
    this.formTwo.markAsUntouched();
    this.formTwo.markAsPristine();

    if (['HO', 'BR', 'TXN'].includes(this.rowData.LE_TYPE)) {
      this.syncButtonsEnabled = true;
      this.mefTablesDisable = false;
    }
    else {
      this.syncButtonsEnabled = false;
      this.mefTablesDisable = true;
    }

    if (!("FILING_GROUP_KEY" in this.rowData) && !("MEF_GROUP_KEY" in this.rowData)) {
      this.allCheckboxesDisable = true;
    }
    else {
      this.allCheckboxesDisable = false;
    }

    if (!("FILING_GROUP_KEY" in this.rowData)) {
      this.fgEmpty = true;
    }
    else {
      this.fgEmpty = false;
    }

    if (this.rowData.LE_TYPE === 'HO') {
      if (this.fgEmpty) {
        this.disableSave = false;
      }
      else {
        this.disableSave = true;
      }
    }
    else {
      this.disableSave = true;
    }


  }

  onDPOpen(): void { // styling fix for gtw-ui
    const modalEle: Element | null = document.querySelector('ngx-daterangepicker-material');
    modalEle?.classList.add('gtw-web-components');
  }

  onSelectedDatesChange(selectedDates: Date[], fieldName: 'returnDate' | 'filterTaxYearBegin' | 'filterTaxYearEnd' | 'dateFiled'): void {
    const selectedDate = Array.isArray(selectedDates) && selectedDates.length > 0 ? selectedDates[0] : null;
    if (fieldName === 'dateFiled') {
      this.dateFiledDates = this.toDateArray(selectedDate);
      this.formTwo.get('dateFiled')?.setValue(selectedDate);
      this.formTwo.get('dateFiled')?.markAsTouched();
      return;
    }
    if (fieldName === 'returnDate') {
      this.returnDateDates = this.toDateArray(selectedDate);
    } else if (fieldName === 'filterTaxYearBegin') {
      this.filterTaxYearBeginDates = this.toDateArray(selectedDate);
    } else if (fieldName === 'filterTaxYearEnd') {
      this.filterTaxYearEndDates = this.toDateArray(selectedDate);
    }
    this.formOne.get(fieldName)?.setValue(selectedDate);
    this.formOne.get(fieldName)?.markAsTouched();
  }

  toDateArray(value: any): Date[] {
    // Return [date, date] (same date twice) to trick AppKit4 into treating it as a "range"
    // where start === end, which prevents the "range-within" highlight effect
    if (!value) return [];
    if (value instanceof Date && !isNaN(value.getTime())) return [value, value];
    if (typeof value === 'string' && value.trim() !== '') {
      const d = new Date(value);
      return !isNaN(d.getTime()) ? [d, d] : [];
    }
    return [];
  }

  // Helper methods to check if field should show error
  // Returns false explicitly when field is not touched
  isFieldError(form: FormGroup, fieldName: string): boolean {
    const control = form.get(fieldName);
    if (!control) return false;
    return control.touched === true && control.invalid === true;
  }

  isDateFiledError(): boolean {
    return this.isFieldError(this.formTwo, 'dateFiled');
  }

  isFilingGroupKeyError(): boolean {
    return this.isFieldError(this.formTwo, 'filingGroupKey');
  }

  private formatDateForPayload(value: any): string | null {
    if (!value) {
      return null;
    }
    if (value?.startDate?.format && typeof value.startDate.format === 'function') {
      return value.startDate.format('yyyy-MM-DD');
    }
    if (value instanceof Date) {
      return this.datePipe.transform(value, 'yyyy-MM-dd');
    }
    const parsed = new Date(value);
    if (!isNaN(parsed.getTime())) {
      return this.datePipe.transform(parsed, 'yyyy-MM-dd');
    }
    return null;
  }

  clicked(event: any, tableName: string, priority: number) {
    const isChecked = event?.checkboxState ?? event?.srcElement?.checked ?? false;
    if (isChecked) {
      this.add(tableName, priority);
    } else {
      this.remove(tableName);
    }
    this.sortData();
    this.clobDataEmpty = this.clob_data.length === 0;
  }

  isTableSelected(tableName: string): boolean {
    return this.clob_data.some((data: any) => data?.table_name === tableName);
  }

  add(tableName: string, priority: number): void {

    this.clob_data.push({
      ...this.rowData,
      table_name: tableName,
      type: 'D',
      priority: priority
    })
  }

  remove(tableName: string): void {
    this.clob_data.forEach((data: any, index: number) => {
      if (tableName == data.table_name) {
        this.clob_data.splice(index, 1);
      }
    })
  }

  sortData(): void {
    this.clob_data.sort((a, b) => {
      return a.priority - b.priority;
    })
  }

  deleteMefEfileData() {
    if (this.clobDataEmpty) {
      this.mefEfileService.openSnackBar("Please select a table to delete!", 'gtw-snackbar--red');

    } else {
      this.loader = true;
      let params = {
        tax_year: this.baseGlobalParams?.tax_year,
        scenario: this.baseGlobalParams?.scenario,
        jcd_key: this.baseGlobalParams?.jcd_key,
        le_type: this.rowData.LE_TYPE,
      }
      let clob_settings = { tax_year: params.tax_year, scenario: params.scenario, jcd_key: params.jcd_key };
      this.mefEfileService.deleteMEf(this.baseURLs.api, params, clob_settings, this.clob_data, this.scenarioCode, this.isIssueKeyEnabled, this.issueKey,).subscribe((data) => {
        if (data !== 'error') {
          this.requestGridUpdate.emit('refresh');
          this.loader = false;
        }
        else {
          console.log("Error while saving");
          this.loader = false;
        }
      }, () => {
        console.log("Error while saving");
        this.loader = false;
      });
    }

  }

  public sync(process_name: string) {
    if (this.rowData) {
      let params = {
        tax_year: this.baseGlobalParams?.tax_year,
        scenario: this.baseGlobalParams?.scenario,
        jcd_key: this.baseGlobalParams?.jcd_key,
        le_key: this.rowData.LE_KEY,
        filing_grp_key: this.rowData.FILING_GROUP_KEY ? this.rowData.FILING_GROUP_KEY : null,
        consol_grp_key: this.rowData.CONSOL_GROUP_KEY,
        mef_grp_key: this.rowData.MEF_GROUP_KEY ? this.rowData.MEF_GROUP_KEY : null,
        grp_type: this.rowData.GROUP_TYPE,
        process_name: process_name,
        form_filer_ind: this.rowData.FORM_FILER_IND,
      }
      this.mefEfileService.sync(this.baseURLs.api, params, this.scenarioCode, this.isIssueKeyEnabled, this.issueKey,)?.subscribe((data) => {
        if (data !== 'error') {
          this.requestGridUpdate.emit('refresh');
          this.loader = false;
        }
        else {
          console.log("Error while saving");
          this.loader = false;
        }
      }, () => {
        console.log("Error while saving");
        this.loader = false;
      });
      this.dialog.closeAll();
    }

  }

  insertFilingData() {
    // Mark all fields as touched to show validation errors
    this.formOne.markAllAsTouched();
    
    if(this.formOne.invalid) {
      this.mefEfileService.openSnackBar("Please enter all the required fields!", 'gtw-snackbar--red');
      return;
    }
    this.loader = true;
    
    let params = {
      tax_year: this.baseGlobalParams?.tax_year,
      scenario: this.baseGlobalParams?.scenario,
      jcd_key: this.baseGlobalParams?.jcd_key,
      type: "I",
    }
    let clob_settings = { tax_year: params.tax_year, scenario: params.scenario, jcd_key: params.jcd_key };
    let clob_data = [{
      le_key: this.rowData.LE_KEY,
      consol_group_key: this.rowData.CONSOL_GROUP_KEY,
      le_name: this.rowData.LE_NAME,
      parent_le_key: this.rowData.parent_le_key,
      return_date: this.formatDateForPayload(this.formOne.value.returnDate),
      irs_center_name: this.formOne.value.irsCenterName,
      filer_tax_year_begin: this.formatDateForPayload(this.formOne.value.filterTaxYearBegin),
      filter_tax_year_end: this.formatDateForPayload(this.formOne.value.filterTaxYearEnd),
      table_name: 'TGT_FILING_GROUP'
    }]
    this.mefEfileService.saveFilingData(this.baseURLs.api, params, clob_settings, clob_data, this.scenarioCode, this.isIssueKeyEnabled, this.issueKey,).subscribe((data) => {
      if (data !== 'error') {
        this.requestGridUpdate.emit('refresh');
        this.loader = false;
      }
      else {
        console.log("Error while saving");
        this.loader = false;
      }
    }, () => {
      console.log("Error while saving");
      this.loader = false;
    });
  }

  insertEntityAssignData() {
    // Mark all fields as touched to show validation errors
    this.formTwo.markAllAsTouched();
    
    if(this.formTwo.invalid) {
      this.mefEfileService.openSnackBar("Please enter all the required fields!", 'gtw-snackbar--red');
      return;
    }
    this.loader = true;
    console.log(this.formOne)
    let params = {
      tax_year: this.baseGlobalParams?.tax_year,
      scenario: this.baseGlobalParams?.scenario,
      jcd_key: this.baseGlobalParams?.jcd_key,
      type: "I",
    }
    let clob_settings = { tax_year: params.tax_year, scenario: params.scenario, jcd_key: params.jcd_key };
    let clob_data = [{
      filing_group_key: this.formTwo.value.filingGroupKey,
      le_key: this.rowData.LE_KEY,
      filer_status: 'A',
      date_filed: this.formatDateForPayload(this.formTwo.value.dateFiled),
      lock_y_n: this.formTwo.value.lockYN,
      source_system_flag: this.formTwo.value.fgnDomFlag,
      le_consol_type_flag: this.formTwo.value.leConsolTypeFlag,
      table_name: 'TGT_FILING_ENTITY_ASSIGN'
    }]
    this.mefEfileService.saveFilingData(this.baseURLs.api, params, clob_settings, clob_data, this.scenarioCode, this.isIssueKeyEnabled, this.issueKey,).subscribe((data) => {
      if (data !== 'error') {
        this.requestGridUpdate.emit('refresh');
        this.loader = false;
      }
      else {
        console.log("Error while saving");
        this.loader = false;
      }
    }, () => {
      console.log("Error while saving");
      this.loader = false;
    });
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }

  /** Re-position body-attached AppKit calendar on open; enable outside-click close (disabled by AppKit when attachedDOM is set). */
  onDatepickerShow(fieldId: string): void {
    requestAnimationFrame(() => {
      window.dispatchEvent(new Event('scroll'));
    });
    this.bindDatepickerOutsideCloseListener();
  }

  onDatepickerClose(): void {
    setTimeout(() => {
      if (!this.hasOpenDatepicker()) {
        this.unbindDatepickerOutsideCloseListener();
      }
    }, 0);
  }

  ngOnDestroy(): void {
    this.unbindDatepickerOutsideCloseListener();
  }

  private hasOpenDatepicker(): boolean {
    return this.datepickerFieldIds.some((fieldId) => {
      const fieldHost = this.getDateFieldHost(fieldId);
      return !!fieldHost?.querySelector('.ap-field-container.open');
    });
  }

  private getDateFieldHost(fieldId: string): Element | null {
    return document.getElementById('field-input-' + fieldId)?.closest('ap-field') ?? null;
  }

  private bindDatepickerOutsideCloseListener(): void {
    if (this.datepickerOutsideListener) {
      return;
    }

    this.datepickerOutsideListener = (event: MouseEvent) => {
      const target = event.target as Node | null;
      if (!target) {
        return;
      }

      for (const fieldId of this.datepickerFieldIds) {
        const fieldHost = this.getDateFieldHost(fieldId);
        if (!fieldHost?.querySelector('.ap-field-container.open')) {
          continue;
        }

        const datepicker = document.getElementById('datepicker-' + fieldId);
        const dialogContainer = datepicker?.closest('.ap-dialog-container');
        const clickedInsideField = fieldHost.contains(target);
        const clickedInsidePicker = !!(datepicker?.contains(target) || dialogContainer?.contains(target));

        if (!clickedInsideField && !clickedInsidePicker) {
          this.closeDatepickerField(fieldId);
        }
      }
    };

    setTimeout(() => {
      if (this.datepickerOutsideListener) {
        document.addEventListener('mousedown', this.datepickerOutsideListener, true);
      }
    }, 0);
  }

  private closeDatepickerField(fieldId: string): void {
    const fieldHost = this.getDateFieldHost(fieldId);
    const calendarBtn = fieldHost?.querySelector('.ap-field-icon-btn') as HTMLElement | null;
    calendarBtn?.click();
  }

  private unbindDatepickerOutsideCloseListener(): void {
    if (!this.datepickerOutsideListener) {
      return;
    }
    document.removeEventListener('mousedown', this.datepickerOutsideListener, true);
    this.datepickerOutsideListener = null;
  }

  onTabChanged(event: number): void {
    const nextMainTabIndex = Number(event);
    this.mainTabIndex = Number.isInteger(nextMainTabIndex) ? nextMainTabIndex : 0;
    if (this.mainTabIndex !== 1) {
      this.nestedTabIndex = 0;
    }
  }

  onNestedTabChanged(event: number): void {
    const nextNestedTabIndex = Number(event);
    this.nestedTabIndex = Number.isInteger(nextNestedTabIndex) ? nextNestedTabIndex : 0;
    
    // Reset form state when switching tabs - prevent showing errors before user interaction
    if (this.nestedTabIndex === 1) {
      // Reset formTwo when switching to Entity Assign tab
      Object.keys(this.formTwo.controls).forEach(key => {
        const control = this.formTwo.get(key);
        if (control && !control.value) {
          // Only reset untouched state for empty fields
          control.markAsUntouched();
          control.markAsPristine();
        }
      });
    }
  }
  openDialog(): void {
    this.dialog.open(ConfirmDialog, {
      width: '400px',
    });
  }
}


@Component({
  selector: 'confirm-dialog',
  templateUrl: 'confirm-dialog.html',
  styleUrls: ['./mef-efile-changes.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ConfirmDialog {
  constructor(public dialogRef: MatDialogRef<ConfirmDialog>, public service: AdminService) { }
  public sync(process_name: string) {
    this.service.informSync(process_name);
  }
  cancel() {
    this.service.informClose();
  }
}